export default {
  // 侧边栏默认折叠状态
  menu: {
    sidebarCollapse: false
  },
  // 在读取持久化数据失败时默认页面
  page: {
    opened: [{
      name: 'index',
      fullPath: '/index',
      meta: {
        title: '首页',
        auth: false
      }
    }]
  },
  // 注册的主题
  theme: {
    list: [{
      title: 'U8SDK 默认主题',
      name: 'u8'
    }, {
      title: 'U8SDK 蓝色主题',
      name: 'blue'
    }]
  },
  // 是否默认开启页面切换动画
  transition: {
    active: true
  }
};